module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskSort2-2703e091254b9ac1eda9014d465ff404.jpg";